import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import DoneIcon from '@material-ui/icons/Done'
import { useSelector } from 'react-redux'

const useStyles = makeStyles(theme => ({
    wrapper: {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: 50
    },
    doneIcon: {
        height: 40,
        width: 40,
        color: theme.active,
        marginLeft: 12
    }
}))

export default function SharingSuccess(props){
    const classes = useStyles()

    const { locale } = useSelector(state => state.main)

    return (
        <div className={classes.wrapper}>
            <div>
                {locale.sharing.successShare}
            </div>
            <DoneIcon className={classes.doneIcon}/>
        </div>
    )
}
